<template>
  <BasePageContainer class="records-top pt-8">
    <PageHeader has-back>
      記録一覧
    </PageHeader>

    <div class="records-top__menu">
      <div
        v-if="isManager"
        class="records-top__menu-item">
        <BaseButton
          class="records-top__menu-button"
          @click="$router.push({ name: 'recordListProfileSelect' })">
          マイデータの一覧
        </BaseButton>
        <p class="records-top__menu-description">
          成績・身長体重・進路希望などマイデータ内の項目を一覧できます
        </p>
      </div>

      <div class="records-top__menu-item">
        <BaseButton
          class="records-top__menu-button"
          @click="$router.push({ name: 'recordListMandalaGoalSelect' })">
          目標チャートの一覧
        </BaseButton>
        <p class="records-top__menu-description">
          メンバーの行動目標と毎月の自己評価を一覧できます
        </p>
      </div>
    </div>
  </BasePageContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@/components/parts/PageHeader.vue'
import BaseButton from '@/components/parts/BaseButton.vue'

export default {
  components: {
    PageHeader,
    BaseButton,
  },
  computed: {
    ...mapGetters('auth', ['isManager']),
  },
}
</script>

<style lang="scss" scoped>
.records-top {
  // Bootstrap の .container が左右 15px を付けるため、モバイルだけ上書きする
  @media (max-width: 767px) {
    padding-right: 24px;
    padding-left: 24px;
  }

  @media (min-width: 992px) {
    max-width: 100%;
    margin-left: 0;
    padding-left: 80px;
  }

  &__menu {
    display: flex;
    flex-direction: column;
    gap: 48px;
    padding-top: 48px;

    @media (min-width: 992px) {
      padding-top: 120px;
    }
  }

  &__menu-item {
    display: flex;
    align-items: center;
    gap: 24px;

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
  }

  // ボタンは同じ幅・同じ左端に揃える（先方確認済み 2026-09-02）
  &__menu-button {
    width: 240px;
    flex-shrink: 0;

    @media (max-width: 767px) {
      width: 100%;
    }
  }

  &__menu-description {
    margin: 0;
    font-size: $fs-nm;
    color: $black;
    line-height: 1.6;
  }
}
</style>
